<template>
    <div>
        <pc-alert v-bind="alertBinder">
            <div>
                <div class="mb-3">
                    {{ smartTemplateMessage }}
                </div>
                <div class="d-flex align-items-center mb-3">
                    <pc-button
                        v-if="analyzeOnly"
                        v-on:click="onBulkUpgrade(true)">
                        {{ analyzeButtonLabel }}
                    </pc-button>
                    <pc-button
                        v-if="!analyzeOnly"
                        primary
                        v-on:click="onBulkUpgrade(false)">
                        {{ upgradeButtonLabel }}
                    </pc-button>
                </div>
                <div>
                    <pc-transition transition="slide">
                        <div
                            v-if="moreInfo"
                            class="mb-3">
                            <p>
                                {{ brokenTagMessage }}
                            </p>
                            <p v-if="!isCommunicationTemplates">
                                {{ documentTemplateBrokenTagMessage }}
                            </p>
                            <p v-if="isCommunicationTemplates">
                                {{ communicationTemplateBrokenTagMessage }}
                            </p>
                        </div>
                    </pc-transition>
                    <pc-button
                        link
                        class="p-0"
                        v-on:click="toggleMoreInfo">
                        {{ moreInfoBtnLabel }}
                    </pc-button>
                </div>
            </div>
        </pc-alert>
    </div>
</template>
<script>
    import { ALERT_SEVERITY } from "Util/alerts";
    import { KEYS, NAMESPACE } from "./i18n/bulkUpgrade.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        props: {
            analyzeOnly: { type: Boolean, required: false, default: false },
            isCommunicationTemplates: { type: Boolean, required: false, default: false }
        },
        emits: ["bulk-upgrade"],
        data() {
            return {
                moreInfo: false
            };
        },
        computed: {
            moreInfoBtnLabel() {
                return this.moreInfo ? this.hideLabel : this.moreInfoLabel;
            },
            alertBinder() {
                return {
                    title: this.smartTemplateTitle,
                    shown: true,
                    severity: ALERT_SEVERITY.info,
                    class: "mb-0"
                };
            },
            ...mapI18n(KEYS, NAMESPACE)
        },
        methods: {
            toggleMoreInfo() {
                this.moreInfo = !this.moreInfo;
            },
            onBulkUpgrade(analyzeOnly) {
                this.$emit("bulk-upgrade", analyzeOnly);
            }
        }
    };
</script>
